import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=7406b4fc&scoped=true"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=7406b4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406b4fc",
  null
  
)

export default component.exports